import { Injectable }    from '@angular/core';
import { Observable }    from 'rxjs';
import * as _ from 'lodash';

import { Auth } from '../auth.service';
import { RequestService } from '../request.service';
import { UserService } from '../users/user.service';

import { Call } from '../../classes/call';
import { Patient } from '../../classes/patient';
import { Doctor } from '../../classes/doctor';
import { JsonpModule } from '@angular/http';
import { linkSync } from 'fs';
import 'rxjs/Rx' ;


const Moment = require('moment');

@Injectable()
export class CallService extends UserService{

  protected getUsersUrl(): string {

    return 'calls';
  };

  protected getOneUserUrl(): string {

    return 'call';
  };

  protected parseObject(obj: any): Call {

    return obj as Call;
  };

  protected parseArray(objs: any): Call[] {

    return objs as Call[];
  };

  constructor(protected requestService: RequestService, protected auth: Auth) {
    super(requestService, auth);
  };

  createCall(params): Promise<Call> {

    return this.requestService.makeRequest({
      urlKey: "createCall",
      method: 'post',
      body: JSON.stringify(params)
    })
    .then((obj) => {
      return obj.json() as Call;
    })
  }

  getCalls(params: any): Promise<any[]> {

    return this.requestService.makeRequest({
      urlKey: this.getUsersUrl(),
      urlQueryParams: params
    })
      .then((response: any) => this.parseArray(response.json()));
  };

  getOne(id: string): Promise<any> {

    return this.requestService.makeRequest({
      urlKey: this.getOneUserUrl(),
      urlParams: {
        id: id
      }
    })
      .then((response: any) => this.parseObject(response.json()));
  };

  sendMedicalCareRecord(params): Promise<any> {

    return this.requestService.makeRequest({
      urlKey: "sendMedicalCareRecord",
      method: 'post',
      body: JSON.stringify(params)
    })
      .then((response: any) => this.parseObject(response.json()));
  };

  sendDoctorToPrescribe(params): Promise<any> {

    return this.requestService.makeRequest({
      urlKey: "sendDoctorToPrescribe",
      method: 'post',
      body: JSON.stringify(params)
    })
      .then((response: any) => this.parseObject(response.json()));
  };

  getPrescriptionsPdfs(id: string): Promise<any> {
    return this.requestService.makeRequest({
      method: 'get',
      urlKey: 'prescriptionsPdfs',
      urlParams: {
        id
      },
    })
    .then((response: any) => {
      return response.json()
    });
  }

  sendFilesToMail(id: string): Promise<any> {
    return this.requestService.makeRequest({
      method: 'get',
      urlKey: 'callFiles',
      urlParams: {
        id
      },
      urlQueryParams: { toMail: true }
    })
    .then((response: any) => {
      return response.json()
    });
  }

  deleteFarmalinkPrescription(params): Promise<any> {
    return this.requestService.makeRequest({
      urlKey: "deleteFarmalinkPrescription",
      method: 'put',
      body: JSON.stringify(params)
    })
      .then((response: any) => this.parseObject(response.json()));
  };

  resendFarmalinkPrescription(params): Promise<any> {
    return this.requestService.makeRequest({
      urlKey: "resendFarmalinkPrescription",
      method: 'put',
      body: JSON.stringify(params)
    })
      .then((response: any) => this.parseObject(response.json()));
  };

  getStates(): Promise<any>{
    return this.requestService.makeRequest({
      urlKey: "callStates",
      method: 'get'
    })
    .then((response: any) => this.parseObject(response.json()));
  }

  notifyToSendFilesByWhatsApp(callId, data): Promise<any> {
    return this.requestService.makeRequest({
      urlKey: "sendFilesByWhatsapp",
      method: "post",
      urlParams: {
        id: callId
      },
      body: JSON.stringify(data)
    })
    .then((response: any) => this.parseObject(response.json()));
  }

  invalidate(callId, params) {
    return this.requestService.makeRequest({
      urlKey: "invalidateCall",
      method: 'put',
      urlParams: {
        id: callId
      },
      body: JSON.stringify(params)
    })
      .then((response: any) => this.parseObject(response.json()));
  }

  validate(callId, params) {
    return this.requestService.makeRequest({
      urlKey: "validateCall",
      method: 'put',
      urlParams: {
        id: callId
      },
      body: JSON.stringify(params)
    })
      .then((response: any) => this.parseObject(response.json()));
  }

  sendCallReportEmail(callId: string, callReportEmails: string): Promise<any> {
    const params = { email: callReportEmails };

    return this.requestService.makeRequest({
      urlKey: "sendCallReportEmail",
      method: "post",
      urlParams: {
        id: callId
      },
      body: JSON.stringify(params)
    })
    .then((response: any) => this.parseObject(response.json()));
  }

  getCallLogs(id: string): Promise<any> {
    return this.requestService.makeRequest({
      method: 'get',
      urlKey: 'callLogs',
      urlParams: {
        id
      },
    })
    .then((response: any) => {
      return response.json()
    });
  }

  setForceNotBillable(callId, params) {

    return this.requestService.makeRequest({
      urlKey: "forceNotBillable",
      method: 'put',
      urlParams: {
        id: callId,
      },
      body: JSON.stringify(params)
    })
      .then((response: any) => this.parseObject(response.json()));
  }
};



// WEBPACK FOOTER //
// ./src/app/services/calls/call.service.ts